/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Detail_Buildmanifestrefreshed2Inputs */

const id_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest build disegarkan`)
};

const ms_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifes binaan disegarkan`)
};

const da_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-manifest opdateret`)
};

const de_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-Manifest aktualisiert`)
};

const en_us2_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build manifest refreshed`)
};

const es_es2_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto de compilación actualizado`)
};

const es_mx2_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto de compilación actualizado`)
};

const fil_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-refresh ang manifest ng build`)
};

const fr_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifeste de compilation actualisé`)
};

const it_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest della build aggiornato`)
};

const hu_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build manifest frissítve`)
};

const nl_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-manifest vernieuwd`)
};

const no_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build-manifest oppdatert`)
};

const pl_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest kompilacji odświeżony`)
};

const pt_br2_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto da build atualizado`)
};

const pt_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto da compilação atualizado`)
};

const ro_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest de compilare reîmprospătat`)
};

const fi_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversion manifesti päivitetty`)
};

const sv_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggemanifest uppdaterat`)
};

const vi_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản kê khai bản dựng đã làm mới`)
};

const tr_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı manifestosu yenilendi`)
};

const cs_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest sestavení obnoven`)
};

const bg_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Манифестът на компилацията е опреснен`)
};

const ru_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Манифест сборки обновлён`)
};

const uk_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маніфест збірки оновлено`)
};

const ar_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحديث بيان البنية`)
};

const hi_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड मैनिफ़ेस्ट रिफ्रेश किया गया`)
};

const th_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตแมนิเฟสต์บิลด์แล้ว`)
};

const ja_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルドマニフェストを更新しました`)
};

const zh_cn2_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建清单已刷新`)
};

const zh_hant1_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置清單已重新整理`)
};

const ko_home_pulse_detail_buildmanifestrefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드 매니페스트 새로고침됨`)
};

/**
* | output |
* | --- |
* | "Build manifest refreshed" |
*
* @param {Home_Pulse_Detail_Buildmanifestrefreshed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_detail_buildmanifestrefreshed2 = /** @type {((inputs?: Home_Pulse_Detail_Buildmanifestrefreshed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Detail_Buildmanifestrefreshed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "ms") return ms_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "da") return da_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "de") return de_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "en-US") return en_us2_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "fil") return fil_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "fr") return fr_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "it") return it_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "hu") return hu_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "nl") return nl_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "no") return no_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "pl") return pl_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "pt") return pt_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "ro") return ro_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "fi") return fi_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "sv") return sv_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "vi") return vi_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "tr") return tr_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "cs") return cs_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "bg") return bg_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "ru") return ru_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "uk") return uk_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "ar") return ar_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "hi") return hi_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "th") return th_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "ja") return ja_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_detail_buildmanifestrefreshed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_detail_buildmanifestrefreshed2(inputs)
	return ko_home_pulse_detail_buildmanifestrefreshed2(inputs)
});
export { home_pulse_detail_buildmanifestrefreshed2 as "home.pulse.detail.buildManifestRefreshed" }